import React, { useState } from "react";
import Layout from "../components/Layout";
import config from "../config";
import "./GooseExport.css";

function GooseExport() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${config.api.baseUrl}${config.api.endpoints.goose.export}`
      );
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        throw new Error(
          data?.errors?.general || `Export failed (${response.status})`
        );
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "goose_submissions.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="goose-export-container">
        <div className="goose-export-card">
          <h1 className="goose-export-title">Goose Island 312 Form Export</h1>
          <p className="goose-export-description">
            Download all form submissions as an Excel spreadsheet.
          </p>
          <button
            className="goose-export-button"
            onClick={handleExport}
            disabled={loading}
          >
            {loading ? "Downloading..." : "Download Submissions"}
          </button>
          {error && <p className="goose-export-error">{error}</p>}
        </div>
      </div>
    </Layout>
  );
}

export default GooseExport;
